module.exports = __webpack_public_path__ + "media/2025_Research_Innovation_Global_Impact.220db543.webm";